import { Route, Routes, RouterProvider, createBrowserRouter, Navigate, useLocation, useParams } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import Login from './legacy-components/Login';
import Logout from './legacy-components/Logout';
import Main from './legacy-components/Main';
import Home from './legacy-components/Home';
import Neenor from './legacy-components/neeNor/Neenor';
import Products from './legacy-components/products/Products';
import NewLoadCustomerValidation from './legacy-components/Newload/NewLoadCustomerValidation';
import ProductDetails from './legacy-components/products/ProductDetails';
import UserDetails from './legacy-components/UserDetails';
import Register from './legacy-components/Registration/Register';
import UserProfile from './legacy-components/CompanySetup/UserProfile';
import ListUnifiedLoads from './legacy-components/ListUnifiedLoads';
import ListUnifiedEpoLoads from './legacy-components/ListUnifiedEpoLoads';
import Loads from './legacy-components/LoadList/Loads';
import LoadDetails from './legacy-components/LoadList/LoadDetails';
import UserAdmin from './legacy-components/UserAdmin';
import UserAdminAudit from './legacy-components/UserAdminAudit';
import NeeNorDetails from './legacy-components/neeNor/NeeNorDetails';
import './legacy-components/main.css'; //must be imported before bootstrap
import './App.css'; //must be imported before bootstrap
import 'bootstrap/dist/css/bootstrap.min.css'; // must be imported after main and app css
import ForgotPassword from './legacy-components/ForgotPassword';
import ConfirmReset from './legacy-components/ConfirmReset';
import Activated from './legacy-components/Activated';
import PasswordResetSent from './legacy-components/PasswordResetSent';
import { ErrorBoundary } from 'react-error-boundary';
import DocusignSubmitted from './legacy-components/docusign/DocusignSubmitted';
import DocusignReopen from './legacy-components/docusign/DocusignReopen';
import Maintenance from './legacy-components/refData/Maintenance';
import GenericErrorFallback from './legacy-components/Errors/GenericErrorFallback';
import EpoJobDetails from './legacy-components/EpoListLoads/Details/EpoJobDetails';
import EpoApplications from './legacy-components/Registration/Sign Up/EpoApplications';
import EpoApplicationDetails from './legacy-components/Registration/Sign Up/EpoApplicationDetails';
import EpoExports from './legacy-components/Epo/EpoExports';
import AdditionalEPOFileUpload from './legacy-components/AdditionalEPOFileUpload/AdditionalEPOFileUploadContainer';
import Search from './legacy-components/DataValidation/Search';
import CommodityCodeDetail from './legacy-components/DataValidation/CommodityCodeDetail';
import { SecurityProvider, PrivateRoute } from './legacy-components/Security/security';
import WlpTrader from './legacy-components/WLP/WlpTrader';
import OnBoarding from './legacy-components/OnBoarding/Registration';
import ReportsAdmin from './legacy-components/Reports/ReportsAdmin';
import ReportsResults from './legacy-components/Reports/ReportsResults';
import ReportsList from './legacy-components/Reports/ReportsList';
import EPODownloadView from './legacy-components/AdditionalEPOFileUpload/EPODownloadView';
import GoogleAnalyticsProvider from './legacy-components/GoogleAnalytics';
import UserAdminCommcodes from './legacy-components/UserAdminCommcodes';
import Layout from './Layout';
import BusinessPartners from './legacy-components/BusinessPartners/BusinessPartners';
import BusinessPartnerCard from './legacy-components/BusinessPartners/BusinessPartnerCard';
import CM8CreateNewLoad from './legacy-components/CM8/CM8CreateNewLoad';
import CommodityCodes from './legacy-components/commoditycodes/commoditycodeslist';
import CommodityCodeDetails from './legacy-components/commoditycodes/commoditycodedetails';
import CustomsTech from './legacy-components/customsTech/CustomsTech';
import DeclarationsActions from './legacy-components/Declarations/DeclarationsActions/DeclarationsActions';
import DeclarationsHistory from './legacy-components/Declarations/DeclarationsHistory/DeclarationsHistory';
import UnmatchedDeclarations from './legacy-components/Declarations/UnmatchedDeclarations/UnmatchedDeclarations';
import IpaffsRiskCategorisation from './legacy-components/ipaffs/IpaffsRiskCategorisation';
import OrderFormMasterData from './legacy-components/OrderForm/OrderFormMasterData';
import MaintenanceBannerDetails from './legacy-components/MaintenanceBannerDetails';
import AppSettings from './legacy-components/AppSettings/AppSettings';
import TaricToolLegacy from './legacy-components/TaricTool';
import TaricTool, { TaricToolDetail, TaricToolHistory } from './pages/TaricTool';
import TaricHistory from './legacy-components/DataValidation/TaricHistory';
import SkillsMatrixList from './legacy-components/SkillsMatrix/SkillsMatrixList';
import SkillsMatrixUser from './legacy-components/SkillsMatrix/SkillsMatrixUser';
import Compliance from './legacy-components/complianceRef/Compliance';
import { FormPlayground, ComponentPlayground } from './pages/ComponentPlayground';
import { useWlpData } from './config/wlp';
import { UnifiedLoad } from './legacy-components/UnifiedLoad';
import './styles/wlps/dtw.css';
import './styles/wlps/cabie.css';
import './styles/wlps/floraLinc.css';
import './styles/wlps/tekFreight.css';
import './styles/wlps/zelir.css';
import './styles/wlps/lgl.css';
import './styles/wlps/chillChain.css';
import './styles/wlps/capitalTransport.css';
import './styles/wlps/theunisseExpeditie.css';
import './styles/wlps/paulPonsonby.css';
import './styles/wlps/Alcaline.css';
import './styles/wlps/c3pl.css';
import './styles/wlps/oakland.css';
import './styles/wlps/360pay.css';
import './styles/wlps/completeFreight.css';
import './styles/wlps/manuelSamper.css';
import './styles/wlps/matuska.css';
import { ThemeProvider } from '@mui/material/styles';
import UnifiedQAStoreProvider from './legacy-components/UnifiedLoad/QAChecklistTab/QAStore';
import CM8Client from './legacy-components/UnifiedLoad/CM8/CM8Client';
import CM8NewLoad from './legacy-components/UnifiedLoad/CM8/CM8NewLoad';
import CM8ClientValidation from './legacy-components/UnifiedLoad/CM8/CM8ClientValidation';
import ImportNewLoad from './legacy-components/UnifiedLoad/ImportLoad/ImportLoad';
import LoadCustomerValidation from './legacy-components/UnifiedLoad/NewLoadCustomerValidation';
import FileLoader from './legacy-components/UnifiedLoad/ImportLoad/FileLoader';

/**
 * Handles redirects and ensures URL params and hash values persist
 */
const NavigateWithParams = ({ to }) => {
  const { id } = useParams();
  const { search, hash } = useLocation();
  return <Navigate replace to={{ pathname: id ? `${to}/${id}` : to, search, hash }} />;
};

const Root = () => {
  const { muiTheme } = useWlpData(window.location.host);
  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        refetchOnWindowFocus: false,
      },
    },
  });

  if (process.env.REACT_APP_ENV === 'dev') {
    // Expose query client to window for TanStack Query DevTools; restricted to dev to avoid production security risks
    window.__TANSTACK_QUERY_CLIENT__ = queryClient;
  }

  return (
    <SecurityProvider>
      <QueryClientProvider client={queryClient}>
        <GoogleAnalyticsProvider>
          <ThemeProvider theme={muiTheme}>
            <ErrorBoundary FallbackComponent={GenericErrorFallback}>
              <Routes>
                <Route element={<Layout />}>
                  <Route exact path="/" element={<Home />} auth={false} />
                  <Route path="/Register" element={<Register />} auth={false} />
                  <Route path="/Login" element={<Login />} auth={false} />
                  <Route path="/forgotPassword" element={<ForgotPassword />} auth={false} />
                  <Route path="/confirmReset/:token" element={<ConfirmReset />} auth={false} />
                  <Route path="/Activated/:token" element={<Activated />} auth={false} />
                  <Route path="/PasswordResetSent/" element={<PasswordResetSent />} auth={false} />
                  <Route path="/DocusignSubmitted" element={<DocusignSubmitted />} auth={false} />
                  <Route path="/DocusignReopen" element={<DocusignReopen />} auth={false} />
                  <Route exact path="/" element={<PrivateRoute />}>
                    <Route path="/main" element={<Main />} />
                    <Route path="/DataValidation" element={<Search />} />
                    <Route path="/taric/:id" element={<CommodityCodeDetail />} />
                    <Route path="/neenor" element={<Neenor />} />
                    <Route path="/NeeNorDetails" element={<NeeNorDetails />} />
                    <Route path="/products" element={<Products />} />
                    <Route path="/ProductDetails" element={<ProductDetails />} />
                    <Route path="/Newload/:id?" element={<NavigateWithParams to="/load" />} />
                    <Route path="/NewLoadFileUpload" element={<NavigateWithParams to="/load/import" />} />
                    <Route path="/NewLoadCustomerValidation/:id" element={<NewLoadCustomerValidation />} />
                    <Route path="/ListLoads" element={<NavigateWithParams to="/cabie/loads" />} />
                    <Route path="/cabie/loads" element={<ListUnifiedLoads />} />
                    <Route path="/epo/loads" element={<ListUnifiedEpoLoads />} />
                    <Route path="/LoadDetails" element={<LoadDetails />} />
                    <Route path="/Loads/:id" element={<Loads />} />
                    <Route path="/UserDetails/new" element={<UserDetails />} />
                    <Route path="/UserDetails/:id" element={<UserDetails />} />
                    <Route path="/Userprofile/:currentTab" element={<UserProfile />} />
                    <Route path="/Userprofile" element={<UserProfile />} />
                    <Route path="/UserAdmin" element={<UserAdmin />} />
                    <Route path="/UserAdminAudit" element={<UserAdminAudit />} />
                    <Route path="/Logout" element={<Logout />} />
                    <Route path="/Maintenance" element={<Maintenance />} />
                    <Route path="/Compliance" element={<Compliance />} />
                    <Route path="/EpoListLoads" element={<NavigateWithParams to="/epo/loads" />} />
                    <Route path="/EpoJobDetails/:id" element={<EpoJobDetails />} />
                    <Route path="/EpoApplications" element={<EpoApplications />} />
                    <Route path="/EpoApplicationDetails/:id" element={<EpoApplicationDetails />} />
                    <Route path="/AdditionalEPOFileUpload/:id" element={<AdditionalEPOFileUpload />} />
                    <Route path="/EPODownloads" element={<EPODownloadView />} />
                    <Route path="/EpoExports" element={<EpoExports />} />
                    <Route path="/WlpTrader" element={<WlpTrader />} />
                    <Route path="/OnBoarding" element={<OnBoarding />} />
                    <Route path="/ReportsAdmin/:reportName?" element={<ReportsAdmin />} />
                    <Route
                      path="/ReportsResults/:endPoint?/:reportName?/:paramCombination?"
                      element={<ReportsResults />}
                    />
                    <Route
                      path="/ReportsResults/:endPoint?/:reportName?/:paramCombination?/:startDate?/:endDate?"
                      element={<ReportsResults />}
                    />
                    <Route
                      path="/ReportsResults/:endPoint?/:reportName?/:paramCombination?/:startDate?/:endDate?/:customer?"
                      element={<ReportsResults />}
                    />
                    <Route
                      path="/ReportsResults/:endPoint?/:reportName?/:paramCombination?/:startDate?/:endDate?/:startDate2?/:endDate2?"
                      element={<ReportsResults />}
                    />
                    <Route
                      path="/ReportsResults/:endPoint?/:reportName?/:paramCombination?/:startDate?/:endDate?/:startDate2?/:endDate2?/:customer?"
                      element={<ReportsResults />}
                    />
                    <Route
                      path="/ReportsResults/:endPoint?/:reportName?/:paramCombination?/:customer?"
                      element={<ReportsResults />}
                    />
                    <Route path="/ReportsList" element={<ReportsList />} />
                    <Route path="/UserAdminCommcodes" element={<UserAdminCommcodes />} />
                    <Route path="/BusinessPartners" element={<BusinessPartners />} />
                    <Route path="/businesspartner/:id" element={<BusinessPartnerCard />} />
                    <Route path="/CM8Clients" element={<NavigateWithParams to="/load/cm8/client" />} />
                    <Route
                      path="/CM8CustomerValidation/:id"
                      element={<NavigateWithParams to="/load/cm8/validation" />}
                    />
                    <Route path="/CM8CreateNewLoad/:id" element={<CM8CreateNewLoad />} />
                    <Route path="/CommodityCodes" element={<CommodityCodes />} />
                    <Route path="/CommodityCodeDetails/:id" element={<CommodityCodeDetails />} />
                    <Route path="/customstech" element={<CustomsTech />} />
                    <Route path="/ipaffs" element={<IpaffsRiskCategorisation />} />
                    <Route path="/orderformtable" element={<OrderFormMasterData />} />
                    <Route path="/MaintenanceBanner" element={<MaintenanceBannerDetails />} />
                    <Route path="/TaricTool" element={<TaricToolLegacy />} />
                    <Route path="/taric-tool" element={<TaricTool />} />
                    <Route path="/taric-tool/:commodityCode/history" element={<TaricToolHistory />} />
                    <Route path="/taric-tool/:commodityCode" element={<TaricToolDetail />} />
                    <Route path="/taric/:id/history" element={<TaricHistory />} />
                    <Route path="/DeclarationsHistory/:loadId/:portalId" element={<DeclarationsHistory />} />
                    <Route path="/DeclarationsActions/:id" element={<DeclarationsActions />} />
                    <Route path="/DeclarationsActions/:id/:loadId/:portalId" element={<DeclarationsActions />} />
                    <Route path="/UnmatchedDeclarations" element={<UnmatchedDeclarations />} />
                    <Route path="/AppSettings" element={<AppSettings />} />
                    <Route path="/SkillsMatrix" element={<SkillsMatrixList />} />
                    <Route path="/SkillsMatrix/:id?" element={<SkillsMatrixUser />} />
                    <Route path="/load/cm8/client" element={<CM8Client />} />
                    <Route path="/load/cm8/:id" element={<CM8NewLoad />} />
                    <Route path="/load/cm8/validation/:id" element={<CM8ClientValidation />} />

                    <Route
                      path="/load/:id?"
                      element={
                        <UnifiedQAStoreProvider>
                          <UnifiedLoad />
                        </UnifiedQAStoreProvider>
                      }
                    />
                    <Route path="/load/import" element={<ImportNewLoad />} />
                    <Route path="/load/fileUpload" element={<FileLoader />} />
                    <Route path="/load/customerValidation/:id" element={<LoadCustomerValidation />} />

                    {process.env.REACT_APP_ENV !== 'prod' && (
                      <>
                        <Route path="/ComponentPlayground" element={<ComponentPlayground />} />
                        <Route path="/FormPlayground" element={<FormPlayground />} />
                      </>
                    )}
                  </Route>

                  <Route path="*" element={<Login />} />
                </Route>
              </Routes>
            </ErrorBoundary>
          </ThemeProvider>
        </GoogleAnalyticsProvider>
      </QueryClientProvider>
    </SecurityProvider>
  );
};

const router = createBrowserRouter([{ path: '*', element: <Root /> }]);

const App = () => {
  return <RouterProvider router={router} />;
};

export default App;
